module.exports = __webpack_public_path__ + "static/img/wuwangluo_51@2x.59824f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/wuwangluo_51@2x.png
// module id = f5sW
// module chunks = 177